import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-boton-svg',
  templateUrl: './boton-svg.component.html',
  styleUrl: './boton-svg.component.scss',
})
export class BotonSvgComponent {

  /**
    * @author Ministerio de cultura
    * @createdate 2025-03-04
    
    * Colores disponibles:
      * purpura
      * purpura-inv
      * azul-electrico 
      * azul-electrico-inv
      * azul-real
      * azul-real-inv
      * azul-cielo
      * azul-cielo-inv
      * turquesa
      * turquesa-inv
      * verde
      * verde-inv
      * verde-lima
      * verde-lima-inv
      * verde-menta-oscuro
      * verde-menta-oscuro-inv
      * amarillo
      * amarillo-inv
      * amarillo-mostaza
      * amarillo-mostaza-inv
      * naranja
      * rojo-fucsia
      * morado
      * transparete-white
      * transparete-negro
      * transparete
      * purpura-grisaceo
      * purpura-grisaceo-inv
      * purpura-indigo
      * purpura-indigo-inv
    

    * Nombre de los botones:
      * agregar
      * agregar-usuario
      * aprobado
      * archivo-aprobado
      * archivo-en-revision
      * apagar
      * calendario
      * campana
      * cancelar
      * cancelar-2
      * configuracion
      * copiar
      * desbloquear
      * descargar
      * editar
      * editar-archivo
      * eliminar
      * enviar
      * etiqueta
      * indicador-informacion
      * llave
      * lupa
      * pdf
      * restaurar
      * roles-de-usuarios
      * simbolo-pesos
      * usuario
      * ver-contenido
      * mesa-ayuda
      * recuperar

  */

  sizeheight: string = '0';
  sizewidth: string = '0';

  @Input() nombre = 'agregar';
  @Input() color = 'morado';
  @Input() colorHover = null;
  @Input() texto: string | null = null;
  @Input() set size(value) {
    const { width, height } = this.detectarFormato(value);
    this.sizewidth = width;
    this.sizeheight = height;
  };
  @Input() borderRadius = '8';
  @Input() isDisabled: boolean = false;
  @Input() notificationCount: number | null = null;

  detectarFormato(valor: string): { width: string; height: string } {
    if (!valor)
      return { width: '25', height: '25' };

    const normalizado = valor.toLowerCase().trim();

    if (/^\d+(\.\d+)?$/.test(normalizado))
      return { width: normalizado, height: normalizado };
    else if (/^\d+(\.\d+)?x\d+(\.\d+)?$/.test(normalizado)) {
      const [width, height] = normalizado.split('x');
      return { width, height };
    }
    else return { width: '25', height: '25' };
  }
}
